module.exports = __webpack_public_path__ + "img/bj.98974d9.png";